export default __webpack_public_path__ + "static/media/savings.e2ae21b3.svg";